var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.orders && _vm.orders[0])?_c('Grid',{attrs:{"col":"12"}},_vm._l((_vm.orders),function(order){return _c('Order',{key:order.order_id,attrs:{"order":order,"theme":"list"}})}),1):(!_vm.loading)?_c('Grid',{staticClass:"block-theme--default",attrs:{"col":"12"}},[_c('Spacer',{attrs:{"x":"s"}},[_c('Spacer',{attrs:{"bottom":"xs"}},[_vm._v(" "+_vm._s(_vm.$labels.no_order)+" ")]),_c('Flex',[_c('Cta',{attrs:{"data":{
          title: `${_vm.$labels.go_to} ${_vm.$labels.shop}`,
          url: '/shop',
        },"theme":"button"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }